import styled from '@emotion/styled';

const Label = styled.label`
  color: #999999;
  margin-top: 10px;
  font-size: 12px;
`;

export default Label;
